import type {
  DtoV1IncomeGetCalculationsVoeResponse,
  DtoV1IncomeGetCalculationsWageEarnerResponse,
} from '~/__generated__/api';
import {
  type CalculationTypes,
  type DocumentTypes,
} from '~/pages/IncomeCalculator/enums';
import type { useIncomeIdentifier } from '~/pages/IncomeCalculator/hooks';

import type useCalculation from './queries/useCalculation';

export type IncomeIdentifier = NonNullable<
  ReturnType<typeof useIncomeIdentifier>['incomeIdentifier']
>;
export type AddressIdentifier = NonNullable<
  ReturnType<typeof useIncomeIdentifier>['addressIdentifier']
>;

export type CalculatorType =
  (typeof CalculationTypes)[keyof typeof CalculationTypes];

export type DocumentType = {
  [K in keyof typeof DocumentTypes]: (typeof DocumentTypes)[K] extends `${infer n extends number}`
    ? n
    : never;
}[keyof typeof DocumentTypes];

export type CalculationResult = ReturnType<
  typeof useCalculation
>['data']['results'][number];

export type W2CalculationResult = CalculationResult &
  DtoV1IncomeGetCalculationsWageEarnerResponse;

export type WvoeCalculationResult = CalculationResult &
  DtoV1IncomeGetCalculationsVoeResponse;

export function isIncomeIdentifier(value: object): value is IncomeIdentifier {
  return (
    typeof value === 'object' &&
    Object.hasOwn(value, 'customerRecordId') &&
    Object.hasOwn(value, 'employerId')
  );
}
